import React from 'react';
import ProgramaPDF from '../assets/Fundación HK - Programa Somos Bakanas.pdf';
import PilaresImage from '../assets/pilares claves.png';

const Programs = React.forwardRef((props, ref) => {
  return (
    <section ref={ref} id="programas" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Qué <span className="text-fhk-cyan-600">Hacemos</span>
          </h2>
          <div className="w-24 h-1 bg-fhk-orange-500 mx-auto rounded-full mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Programas formativos integrales que combinan teoría y práctica para el desarrollo de habilidades STEM y competencias del futuro.
          </p>
        </div>

        {/* Main Program Card */}
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <div className="mb-6">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                  Fundación HK
                </h2>
                <div className="w-24 h-1 bg-fhk-orange-500 rounded-full"></div>
              </div>
              <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
                Programa Somos Backanas
              </h3>
              
              {/* Botón de descarga del programa */}
              <a 
                href={ProgramaPDF} 
                download="Fundación HK - Programa Somos Bakanas.pdf"
                className="inline-flex items-center px-6 py-3 bg-fhk-orange-500 text-white rounded-full font-semibold hover:bg-fhk-orange-600 transition-all duration-300 transform hover:scale-105 shadow-lg mb-6"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Descargar Nuestro Programa (PDF)
              </a>
              
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Este programa se desarrollará en un formato blended, combinando elementos de e-learning, 
                capacitaciones presenciales y actividades prácticas para maximizar aprendizaje y el impacto en las participantes.
              </p>
              
              {/* Program Features */}
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-600">Mentorías: Charlas y talleres con expertos</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-600">Formación de una comunidad virtual</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-600">Visitas a Empresas</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-600">Comunidad virtual de apoyo y colaboración</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-600">Visitas a empresas y experiencias prácticas</p>
                </div>
              </div>
            </div>
            
            {/* Pilares Claves Image */}
            <div className="flex justify-center items-start">
              <img
                src={PilaresImage}
                alt="Pilares Claves del Programa"
                className="w-full max-w-xl h-auto rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>

        {/* Results / Statistics - OCULTO */}
        {/* <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-16">
          <div className="text-center mb-12">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
              Resultados y Estadísticas
            </h3>
            <p className="text-lg text-gray-600">
              El impacto de nuestros programas en números
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-purple-50 to-purple-100">
              <div className="text-4xl font-bold text-purple-600 mb-2">TODO</div>
              <p className="text-lg font-semibold text-gray-800 mb-2">Participantes Activas</p>
              <p className="text-sm text-gray-600">Estudiantes en nuestros programas</p>
            </div>

            <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-pink-50 to-pink-100">
              <div className="text-4xl font-bold text-pink-600 mb-2">TODO</div>
              <p className="text-lg font-semibold text-gray-800 mb-2">Mentoras Activas</p>
              <p className="text-sm text-gray-600">Profesionales comprometidas</p>
            </div>

            <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-blue-50 to-blue-100">
              <div className="text-4xl font-bold text-blue-600 mb-2">TODO</div>
              <p className="text-lg font-semibold text-gray-800 mb-2">Empresas Aliadas</p>
              <p className="text-sm text-gray-600">Oportunidades de empleo</p>
            </div>

            <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-green-50 to-green-100">
              <div className="text-4xl font-bold text-green-600 mb-2">TODO</div>
              <p className="text-lg font-semibold text-gray-800 mb-2">% Colocación</p>
              <p className="text-sm text-gray-600">Tasa de inserción laboral</p>
            </div>
          </div>
        </div> */}

        {/* Success Stories - OCULTO */}
        {/* <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <div className="text-center mb-12">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
              Historias de Impacto
            </h3>
            <p className="text-lg text-gray-600">
              Conoce las experiencias transformadoras de nuestras participantes
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-6 text-center">
              <div className="w-20 h-20 bg-gray-200 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-10 h-10 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
              </div>
              <h4 className="text-lg font-bold text-gray-800 mb-3">TODO: Testimonio 1</h4>
              <p className="text-gray-600 text-sm mb-4">
                "TODO: Extracto del testimonio con foto y nombre de la participante"
              </p>
              <button className="text-purple-600 font-semibold text-sm hover:text-purple-700">
                Leer historia completa →
              </button>
            </div>

            <div className="bg-gradient-to-br from-pink-50 to-pink-100 rounded-2xl p-6 text-center">
              <div className="w-20 h-20 bg-gray-200 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-10 h-10 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
              </div>
              <h4 className="text-lg font-bold text-gray-800 mb-3">TODO: Testimonio 2</h4>
              <p className="text-gray-600 text-sm mb-4">
                "TODO: Extracto del testimonio con foto y nombre de la participante"
              </p>
              <button className="text-pink-600 font-semibold text-sm hover:text-pink-700">
                Leer historia completa →
              </button>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-6 text-center">
              <div className="w-20 h-20 bg-gray-200 rounded-full mx-auto mb-4 flex items-center justify-center">
                <svg className="w-10 h-10 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
              </div>
              <h4 className="text-lg font-bold text-gray-800 mb-3">TODO: Testimonio 3</h4>
              <p className="text-gray-600 text-sm mb-4">
                "TODO: Extracto del testimonio con foto y nombre de la participante"
              </p>
              <button className="text-blue-600 font-semibold text-sm hover:text-blue-700">
                Leer historia completa →
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
});

Programs.displayName = 'Programs';

export default Programs;
